'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var POST = 'POST';
var GET = 'GET';
var DELETE = 'DELETE';
var PUT = 'PUT';
var HEAD = 'HEAD';
var CONNECT = 'CONNECT';
var OPTIONS = 'OPTIONS';
var TRACE = 'TRACE';
var PATCH = 'PATCH';

/**
 * Enum containing all types of HTTP Request to be set on HTTPRequest object.
 */

var RequestMethod = function () {
    function RequestMethod() {
        _classCallCheck(this, RequestMethod);
    }

    _createClass(RequestMethod, null, [{
        key: 'values',
        value: function values() {
            return [POST, GET, PUT, PATCH, TRACE, OPTIONS, CONNECT, HEAD, DELETE];
        }
    }, {
        key: 'POST',
        get: function get() {
            return POST;
        }
    }, {
        key: 'GET',
        get: function get() {
            return GET;
        }
    }, {
        key: 'DELETE',
        get: function get() {
            return DELETE;
        }
    }, {
        key: 'PUT',
        get: function get() {
            return PUT;
        }
    }, {
        key: 'HEAD',
        get: function get() {
            return HEAD;
        }
    }, {
        key: 'CONNECT',
        get: function get() {
            return CONNECT;
        }
    }, {
        key: 'OPTIONS',
        get: function get() {
            return OPTIONS;
        }
    }, {
        key: 'TRACE',
        get: function get() {
            return TRACE;
        }
    }, {
        key: 'PATCH',
        get: function get() {
            return PATCH;
        }
    }]);

    return RequestMethod;
}();

exports.default = RequestMethod;